module.exports = __webpack_public_path__ + "static/media/54_1117.f996a3d1.webp";